<template>
  <div class="logos">
    <logo :logo="logo.sngg"  :inputStyle="{width:'8.24vw'}"></logo>
    <split_bar :inputStyle="splitStyle"></split_bar>
    <logo :logo="logo.kdsj" :inputStyle="{width:'8.0vw'}"></logo>
  </div>
</template>

<script>
 import Logo from '@/components/Logo.vue';
 import SplitBar from '@/components/SplitBar.vue';
 export default {
   name: 'TitleLogo',
   computed: {
     splitStyle (){
       return {
         height: '2vw',
         width: '1px',
         'background-color': 'white'
       }
     },
     logo () {
       return {
         kdsj: this.$store.state.logo.kdsj,
         sngg: this.$store.state.logo.sngg
         /* coco: this.$store.state.logo.coco,
          * fx: this.$store.state.logo.fxWhite, */
       }
     }
   },
   components: {
     logo: Logo,
     split_bar: SplitBar
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .logos {
   margin-top: 2.3vw;
   display: flex;
   align-items:center;
   justify-content: space-between;
   width: 20vw;
 }
</style>
